<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            v-if="!id"
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.code"
            :disabled="!formEditable"
            @change="$set(form, 'code', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.abbreviation"
            :external-errors="errors['abbreviation']"
            :label-form="'Abbreviation' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.abbreviation"
            :disabled="!formEditable"
            :formatter="formatAbbreviation"
            @change="$set(form, 'abbreviation', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as CONTACT_TITLE_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'OrganizationGroupEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Contact title',
      rolePerm: 'organization_contacttitle_retrieve',
      editRolePerm: 'organization_contacttitle_update'
    }
  },
  computed: {
    ...mapGetters({
      ...CONTACT_TITLE_TYPES.GENERIC.organization.contacttitle.DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...CONTACT_TITLE_TYPES.GENERIC.organization.contacttitle.DETAIL.ACTIONS
    }),
    formatAbbreviation (e) {
      return String(e).substring(0, 10)
    },
    getFormData () {
      const formData = Object.assign({}, this.form)
      formData.id = formData.code
      return formData
    }
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      abbreviation: {}
    }
  }
}
</script>
